import React, { Fragment } from "react";
import ReactDOM from "react-dom";

import { BrowserRouter as Router, Switch } from "react-router-dom";
import Routes from "Routes/index";

import "assets/css/material-dashboard-react.css?v=1.6.0";

ReactDOM.render(
  <Router>
    <Switch>
      <Routes />
    </Switch>
  </Router>,
  document.getElementById("root")
);
